import { request } from "../@utils";
import { requestFile } from "../@utils";
const ProductService = {
  //商家商品
  batchDeleteMerchantProduct: async (params) => {
    const res = await request.post("/product/merchant-product/batch-delete",{ data: params });
    return res;
  },
  createMerchantProduct: async (params) => {
    const res = await request.post("/product/merchant-product/create",{ data: params });
    return res;
  },
  createForStore: async (params) => {
    const res = await request.post('/product/merchant-product/create-for-store',{ data: params })
    return res;
  },
  deleteMerchantProduct: async (skuId) => {
    const res = await request.delete(`/product/merchant-product/delete/${skuId}`);
    return res;
  },
  getMerchantProductDetail: async (skuId) => {
    const res = await request.get(`/product/merchant-product/detail/${skuId}`);
    return res;
  },
  getMerchantProductList: async (params) => {
    const res = await request.post("/product/merchant-product/list",{ data: params });
    return res;
  },
  updateMerchantProduct: async (params) => {
    const res = await request.post("/product/merchant-product/update",{ data: params });
    return res;
  },
  exportMerchantProduct: async (params) => {
    const res = await requestFile.post("/product/merchant-product/export",{ data: params,responseType: "blob" });
    return res;
  },
  onShelvesUpdate: async (params) => {
    const res = await request.post("/product/merchant-product/on-shelves",{ data: params });
    return res;
  },
  downShelvesUpdate: async (params) => {
    const res = await request.post("/product/merchant-product/down-shelves",{ data: params });
    return res;
  },
  checkBarCode: async (barcode) => {
    const res = await request.post(`/product/merchant-product/check-barcode/${barcode}
    `);
    return res;
  },
  batchUploadImg: async (params) => {
  },

  //门店商品
  batchStoreOnShelves: async (params) => {
    const res = await request.post("/product/store-product/batch-on-shelves",{ data: params });
    return res;
  },
  batchStoreOffShelves: async (params) => {
    const res = await request.post("/product/store-product/batch-off-shelves",{ data: params });
    return res;
  },
  createStoreProduct: async (params) => {
    const res = await request.post("/product/store-product/create",{ data: params });
    return res;
  },
  deleteStoreProduct: async (params) => {
    const res = await request.post("/product/store-product/delete",{ data: params });
    return res;
  },
  getStoreProductDetail: async (skuId) => {
    const res = await request.get(`/product/store-product/detail/${skuId}`);
    return res;
  },
  getStoreProductList: async (params) => {
    const res = await request.post("/product/store-product/page",{ data: params });
    return res;
  },
  updateBatchArea: async (params) => {
    const res = await request.post("/product/store-product/updateBatchArea",{ data: params });
    return res;
  },
  updateStoreProduct: async (params) => {
    const res = await request.post("/product/store-product/update",{ data: params });
    return res;
  },
  addStoreFileTask: async params => {
    const res = await request.post('/product/store-product/add-file-task', { data: params })
    return res
  },
  exportStoreProduct: async (params) => {
    const res = await requestFile.post("/product/store-product/export",{ data: params,responseType: "blob" });
    return res;
  },
  queryTaxCategory: async (code) => {
    const res = await request.get(`/category-tax/query/${code}`);
    return res;
  },
  addFileTask: async params => {
    const res = await request.post('/product/merchant-product/add-file-task', { data: params })
    return res
  },
};
export default ProductService;